import React from 'react';
import PropTypes from 'prop-types';

const BatchUpload = ({
  files,
}) => (
  <div>
    <p>Files</p>
    <ul>
      {files.map((file) => (
        <li key={file.name}>{file.name}</li>
      ))}
    </ul>
  </div>
);

BatchUpload.propTypes = {
  files: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default BatchUpload;
